import { gql } from '@apollo/client';
import {
  CompletedJoinRequest,
  GetJoinRequestsParams,
  JoinRequestSlimForList,
  JoinRequestsSortOptions,
} from 'spw-redux/modules/join-requests/types';
import { graphqlClient } from './utils';

export const getJoinRequestsForAllTeams = (params: GetJoinRequestsParams) =>
  graphqlClient.query<{
    results: {
      total: number;
      joinRequests: JoinRequestSlimForList[];
    };
  }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetJoinRequestsForAllTeams(
        $sort: JoinRequestsSortOptions
        $perPage: Int
        $page: Int
      ) {
        results: getJoinRequestsForAllTeams(
          perPage: $perPage
          page: $page
          sort: $sort
        ) {
          total
          joinRequests {
            id
            insertedAt
            status
            user {
              id
              name
              officeLocation
              professionalRole
              hasAvatar
              thumbnailS3Path
            }
            team {
              id
              name
              hasLogo
              thumbnailS3Path
            }
          }
        }
      }
    `,
    variables: params,
  });

export const getUserPendingProjectRequests = (projectId?: number) =>
  graphqlClient.query<{ joinRequests: JoinRequestSlimForList[] }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetUserPendingProjectRequests($projectId: ID) {
        joinRequests: getUserPendingJoinRequests(projectId: $projectId) {
          id
          projectId
          status
        }
      }
    `,
    variables: { projectId },
  });

// TODO: add a gql query to get all joinRequests for teams (SPW-2480)
export const getUserPendingTeamRequests = () =>
  graphqlClient.query<{ joinRequests: JoinRequestSlimForList[] }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetUserPendingTeamRequests {
        joinRequests: getUserPendingJoinRequests {
          id
          insertedAt
          teamId
          userId
          status
        }
      }
    `,
  });

export const getJoinRequestsForTeam = (
  id: number,
  params?: GetJoinRequestsParams
) =>
  graphqlClient.query<{
    results: { total: number; joinRequests: JoinRequestSlimForList[] };
  }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query getJoinRequestsForTeam(
        $teamId: Int!
        $sort: JoinRequestsSortOptions
        $perPage: Int
        $page: Int
      ) {
        results: getJoinRequestsForTeam(
          teamId: $teamId
          perPage: $perPage
          page: $page
          sort: $sort
        ) {
          total
          joinRequests {
            id
            insertedAt
            status
            user {
              id
              name
              officeLocation
              professionalRole
              hasAvatar
              thumbnailS3Path
              numberOfTeams
            }
            team {
              id
              name
              hasLogo
              thumbnailS3Path
            }
          }
        }
      }
    `,
    variables: { teamId: id, ...params },
  });

export const getProjectJoinRequests = (params: {
  projectId: number;
  page?: number;
  perPage?: number;
  sort?: JoinRequestsSortOptions;
}) =>
  graphqlClient.query<{
    results: { total: number; joinRequests: JoinRequestSlimForList[] };
  }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query getJoinRequestsForProject(
        $projectId: Int!
        $sort: JoinRequestsSortOptions
        $perPage: Int
        $page: Int
      ) {
        results: getJoinRequestsForProject(
          projectId: $projectId
          perPage: $perPage
          page: $page
          sort: $sort
        ) {
          total
          joinRequests {
            id
            projectId
            status
            insertedAt
            user {
              id
              name
              numberOfTeams
              hasAvatar
              thumbnailS3Path
              professionalRole
              officeLocation
            }
          }
        }
      }
    `,
    variables: params,
  });

export const getUserProjectsJoinRequests = (params: {
  page?: number;
  perPage?: number;
  sort?: JoinRequestsSortOptions;
}) =>
  graphqlClient.query<{
    results: {
      total: number;
      joinRequests: JoinRequestSlimForList[];
    };
  }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetUserProjectsJoinRequests(
        $sort: JoinRequestsSortOptions
        $page: Int
        $perPage: Int
      ) {
        results: getProjectsJoinRequests(
          sort: $sort
          page: $page
          perPage: $perPage
        ) {
          total
          joinRequests {
            id
            project {
              id
              projectName
              projectNumber
              type
              projectOwner {
                id
                name
              }
            }
            status
            insertedAt
            user {
              id
              name
              hasAvatar
              thumbnailS3Path
              officeLocation
              professionalRole
            }
          }
        }
      }
    `,
    variables: params,
  });

export const acceptJoinRequest = (id: number) =>
  graphqlClient.query<{ joinRequest: CompletedJoinRequest }>({
    fetchPolicy: 'no-cache',
    query: gql`
      mutation AcceptJoinRequest($id: Int!) {
        joinRequest: acceptJoinRequest(id: $id) {
          id
          status
        }
      }
    `,
    variables: { id },
  });

export const rejectJoinRequest = (id: number) =>
  graphqlClient.query<{ joinRequest: CompletedJoinRequest }>({
    fetchPolicy: 'no-cache',
    query: gql`
      mutation RejectJoinRequest($id: Int!) {
        joinRequest: rejectJoinRequest(id: $id) {
          id
          status
        }
      }
    `,
    variables: { id },
  });
